// TIILT lab logo (tiilt.northwestern.edu/assets/img/logo.svg), inlined so it
// can be recolored with currentColor.
function TiiltLogo(props) {
    return (
        <svg
            viewBox="0 0 5000 5000"
            role="img"
            aria-label="TIILT lab logo"
            className={props.className}
        >
            <g
                fill="none"
                stroke="currentColor"
                strokeWidth="89.617"
                strokeLinecap="round"
                strokeMiterlimit="10"
            >
                <ellipse cx="2137.8" cy="4295.5" rx="84" ry="84" />
                <path d="M1536.9,2246l365.8,904.8l588.1-237.8" />
                <ellipse cx="1388.5" cy="2508.8" rx="84" ry="84" />
                <path d="M1420.1,2586.6l365.8,904.8l352.3-142.4" />
                <ellipse cx="1461.5" cy="1366.1" rx="84" ry="84" />
                <ellipse cx="706.9" cy="769.4" rx="84" ry="84" />
                <ellipse cx="1010.5" cy="901.2" rx="84" ry="84" />
                <path d="M1476,458.6L784.8,738" />
                <path d="M1579.4,671.2l-491.1,198.6" />
                <path d="M1430.1,1288.2l-193.4-478.4" />
                <ellipse cx="906.5" cy="1305.7" rx="84" ry="84" />
                <path d="M938,1383.6l232.4,574.8l1.5,3.7" />
                <ellipse cx="1203.3" cy="2040.1" rx="84" ry="84" />
                <ellipse cx="1596.5" cy="1699.9" rx="84" ry="84" />
                <path d="M1628,1777.7l232.4,574.8l1.5,3.7" />
                <ellipse cx="1893.3" cy="2434.1" rx="84" ry="84" />
                <ellipse cx="2216" cy="3317.6" rx="84" ry="84" />
                <ellipse cx="2418" cy="4451.2" rx="84" ry="84" />
                <ellipse cx="2505.6" cy="3511.2" rx="84" ry="84" />
                <path d="M1723.4,3829.1l705.1-285.1" />
                <path d="M1819.2,4043.2l611.8-247.4" />
                <path d="M2386.7,4373.1l-193.4-478.3" />
                <path d="M2106.4,4217.5l-96-237.4" />
            </g>
            <g fill="currentColor">
                <path
                    d="M1075.3,228c329.4,0,467.6,346.7,467.6,346.7l368.1,905.8l1179-479.1c0,0,93.6-41.5,210.9-41.5
	c132.8,0,296,53.2,388.2,280.2c173.7,427.5-251.6,616.3-251.6,616.3l-1179,479.1l342.5,842.7c103.4,254.5,222.8,515.2,445.3,515.2
	c38.4,0,80-7.8,125-24.7c299-129.5,212.4-388.1,114.8-628.2l4.7,11.7c0,0-180.7-474.1,274.1-658.9c78.5-31.9,149.2-45.1,212.4-45.1
	c303,0,434.6,303.3,434.6,303.3s295.3,487.3,192,1004.1c-123.8,619.1-454.4,796.9-832.2,950.5C3293.3,4719,3084.3,4764,2896,4764
	c-126.3,0-243.3-20.2-365.6-53.7c-155.8-42.6-276.9-122.6-387.8-209c-193.8-151-318.4-430.4-410.9-658L1280.4,2733l-305.2,124
	c0,0-64.5,23.6-152.8,23.6c-130.4,0-312.8-51.5-416.4-306.3c-173.7-427.5,221.7-572.2,221.7-572.2L933,1878L564.8,972.2
	c0,0-198.7-498.7,290.4-697.4C936.5,241.8,1009.7,228,1075.3,228 M1075.4,8.7c-98.1,0-200,21.2-302.8,62.9
	c-77.5,31.5-146.8,71.2-206.2,118.1c-57.1,45.1-105.9,97.5-145,155.7c-35.3,52.5-62.9,110.3-82.2,171.7
	c-16.4,52.1-26.9,107.3-31.2,164.3c-3.6,46.4-3.1,94.5,1.4,143c3.5,37.9,9.5,76.3,17.9,114.1c14.1,64,30.7,107,33.8,115l0.3,0.7
	l0.3,0.7l285.5,702.6L547.1,1798c-19,7.4-73.7,30.5-136.1,74c-42.5,29.6-81,63.4-114.5,100.2c-43.8,48.2-78.9,101.9-104.4,159.4
	c-33.5,75.7-50.2,157.5-49.6,243.1c0.7,90.5,20.9,185.4,60.2,282.1c32.9,81.1,74.9,152.6,124.7,212.8
	c47.5,57.4,102.7,105,164.1,141.7c53.8,32.2,112.6,55.9,174.5,70.7c50.2,11.9,102.7,18,156.2,18c121.1,0,211.3-30.8,228.2-37
	l3.6-1.3l3.6-1.4l102-41.5l368.7,907.1c47.7,117.4,106.4,254.8,180.2,384c41.8,73.1,83.9,136.3,129,193.2
	c53.3,67.3,110.5,124.9,170.1,171.4c74.4,58,139.1,102,203.5,138.6c85.7,48.7,171.2,84.3,261.2,108.9
	c153.3,41.9,287.9,61.4,423.4,61.4c114,0,229.5-13.8,353.2-42.2c124-28.5,256.5-71.7,405.2-132.1c89.2-36.2,194.1-81,296.2-137.8
	c111.1-61.9,204.5-130.2,285.4-208.6c45.8-44.5,88.3-93.1,126.4-144.5c39.8-53.8,76.1-112.6,107.9-174.7
	c32.5-63.6,61.5-132.9,86-205.9c24.9-74,46-154.4,63-239.1c28-140,33.6-288.8,16.5-442.2c-13.3-119.6-40.3-242.4-80.3-364.8
	c-28.3-86.7-62.4-171.4-101.3-251.6c-21-43.3-38.2-74.5-47.4-90.4c-6.4-13.2-16.9-33.6-31.7-58.4c-30.6-50.9-66.2-98.4-106.1-141
	c-58.3-62.4-123.8-112.7-194.7-149.4c-92.2-47.7-192-71.9-296.6-71.9c-95.7,0-195,20.6-295,61.2c-73.6,29.9-139.6,67.9-196.2,112.8
	c-54.4,43.2-101,93.6-138.3,149.5c-33.6,50.3-60.1,105.7-78.6,164.5c-15.7,49.8-26,102.6-30.4,157.1c-6.6,79.7-1.1,162.4,16.2,245.8
	c10.5,50.3,22.6,87.3,28.2,103.1l-0.3,0.1c27.1,66.8,77.7,191.1,75.3,266c-0.7,23.3-6.3,31.2-8.7,34.6
	c-9.3,13.3-31.1,28.2-60.3,41.4c-16.6,5.8-31.4,8.9-42.9,8.9c-9,0-17.6-1.7-30.1-9.7c-12.6-8.1-33.2-25.5-59.9-62.1
	c-57.6-79.1-108.7-199.7-152.1-306.5L2544.4,2456l975.8-396.6l3.2-1.3l3.2-1.4c10.1-4.5,46.7-21.5,95.1-53.3
	c67.2-44.1,126-95.8,174.8-153.9c33.3-39.6,61.8-82.2,84.5-126.4c26.8-52.1,46.1-107.3,57.4-163.9c12.5-62.7,15.1-127.9,8-193.8
	c-7.4-68.3-25.6-138.3-53.9-208.2c-30.3-74.5-68.9-140.5-114.7-196.3c-44.5-54.1-96.3-99.2-153.9-134.1
	c-51.5-31.2-107.9-54.3-167.7-68.7c-49.5-11.9-101.7-18-155.1-18c-68.2,0-137.9,9.6-207.2,28.5c-44.2,12.1-75.4,24.5-88.4,30
	l-973.6,395.7L1746.5,492c-3.8-9.5-16.2-38.6-38.4-78.6c-31.5-56.5-68.5-109.3-110-156.8c-61-69.8-129.9-126-205-167.2
	C1294.6,36,1187.8,8.7,1075.4,8.7L1075.4,8.7z"
                />
            </g>
        </svg>
    )
}

export { TiiltLogo }
